const CustomResourceApplySPHZB = () => import('@/views/main/report/customResourceApply/CustomResourceApplySPHZB.vue')
export default {
  path: '/main/report/customResourceApplySPHZB',
  name: 'customResourceApplySPHZB',
  component: CustomResourceApplySPHZB,
  children: []
}
